<template>
  <span class="capsule-filter" :class="{ 'capsule-filter--active': props.isActive, 'capsule-filter--icon': props.isIcon }">
    <slot />
  </span>
</template>

<script setup>
  const props = defineProps({
    //Элемент активен?
    isActive: { type: Boolean },
    //Слот является иконкой
    isIcon: { type: Boolean },
  });
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>